module.exports = __webpack_public_path__ + "static/mr-press-03-6bc931ac3fdc1664731c23131bf35ce0.jpg";